import markdownIt from 'markdown-it';
import linkAttributes from 'markdown-it-link-attributes';
import sup from 'markdown-it-sup';

const md = markdownIt()
  .use(sup)
  .use(linkAttributes, {
    target: '_blank',
    rel: 'noopener'
  });

export const markdownToHTML = (string, inlineOnly=false) => (
  inlineOnly ? md.renderInline(string) : md.render(string)
);



// WEBPACK FOOTER //
// ./src/utils/string.js